import {
  Dialog,
  DataService,
  SharedModule,
  ModalService,
  NotificationService,
} from "@bb-vendure/admin-ui/core";
import {
  concat,
  Observable,
  of,
  Subject,
  debounceTime,
  distinctUntilChanged,
  tap,
  switchMap,
  catchError,
  take,
} from "rxjs";
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import {
  FanClubEvent,
  FetchEventsDocument,
  SortOrder,
} from "src/generated-gql/graphql";
import { CreateEventDialogComponent } from "../../create-event-dialog/create-event-dialog.component";

@Component({
  selector: "select-event-modal",
  standalone: true,
  imports: [SharedModule],
  templateUrl: "./select.component.html",
})
export default class SelectEventModalComponent
  implements OnInit, Dialog<FanClubEvent[]>
{


  @Input()
  allowCorporate? : boolean


  ngOnInit(): void {
    this.events$ = concat(
      this.dataService
        .query(FetchEventsDocument, {
          options: {
            take: 5,
            sort: {
              createdAt: SortOrder.Desc,
            },
            filter: {
              isApproved: {
                eq: true,
              },
              isCancelled :{
                eq : false
              },
              endDate: {
                after: new Date().toISOString(),
              },
              allowCorporate : this.allowCorporate ?  {
                eq : this.allowCorporate 
              } : undefined
            },
          },
        })
        .mapSingle(({ fanClubEvents }) => fanClubEvents?.items ?? []),
      this.input$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        tap(() => (this.isLoading = true)),
        switchMap((term) =>
          this.dataService
            .query(FetchEventsDocument, {
              options: {
                filter: {
                  name: {
                    contains: term as string,
                  },
                  isApproved: {
                    eq: true,
                  },
                  endDate: {
                    after: new Date().toISOString(),
                  },
                  allowCorporate : this.allowCorporate ?  {
                    eq : this.allowCorporate 
                  } : undefined
                },
              },
            })
            .mapStream(({ fanClubEvents }) => fanClubEvents.items)
            .pipe(
              catchError(() => of([])),
              tap(() => (this.isLoading = false))
            )
        )
      )
    ) as Observable<FanClubEvent[]>;
  }

  trackByFn(item: FanClubEvent) {
    return item.id;
  }
  cancel() {
    this.resolveWith([]);
  }

  select() {
    this.resolveWith(this.selectedEvent);
  }

  createNewEvent() {
    this.modalService
      .fromComponent(CreateEventDialogComponent, {
        size: "lg",
      })
      .pipe(take(1))
      .subscribe((res) => {
        if (res) {
          this.notificationService.success(
            "Create new event successfully. However, please wait for approval before it can be used."
          );
        }
      });
  }

  input$ = new Subject<string>();
  isLoading = false;
  events$: Observable<FanClubEvent[]>;
  selectedEvent: FanClubEvent[] = [];

  constructor(
    private dataService: DataService,
    private modalService: ModalService,
    private notificationService: NotificationService
  ) {}
  resolveWith: (result?: FanClubEvent[]) => void;
}
